<script lang="ts">
  import Card, { Content, Media } from '@smui/card';
  import { isMobileWidth } from '../../../common/util';
  import HorizontalDivider from '../../common/components/HorizontalDivider.svelte';
  import Icon from '../../common/components/Icon.svelte';
  import Tag from '../../common/components/tag/Tag.svelte';
  import Text from '../../common/components/Text.svelte';
  import { getBlogDateFormat, getBlogImageAltTextFromUrl } from '../services/blog-data-services';
  import { blogBaseUrl } from '../store/blog_store';

  export let data;
  const isResponsive = isMobileWidth();
</script>

<a class="blog-card-container" href={`${$blogBaseUrl}/${data?.blogCategoryid}/${data?.blogPostKey}`}>
  <Card>
    <Media
      class="card-media"
      aspectRatio="16x9"
      style={`background-image:url(${data?.blogImage}?fmt=auto);background-size: cover;
      background-position: center;  background-repeat: no-repeat;`}
    >
      <!-- This is a hack because semantically the alternate text is not on the element that actually has the image. 
       However, from a screen reader perspective the <div> with the background image is ignored and so placing the <span> 
       directly following it will provide that information in a way that will seem as if the alternate text was in the same place as the background image. -->
      <span role="img" aria-label={getBlogImageAltTextFromUrl(data?.blogImage)}> </span>
      {#if data.blogCategoryname}
        <div class="blog-card-tag-container">
          <Tag
            label={data?.blogCategoryname}
            backgroundColorCode="#FFECA1"
            textColorCode="#051F2F"
            fontSize={isResponsive ? 12 : 16}
          />
        </div>
      {/if}
    </Media>
    <Content style="">
      <div class="blog-content-container">
        <div class="blog-content-div">
          {#if data?.blogTitle}
            <span class="blog-title">{data?.blogTitle}</span>
          {/if}
          {#if data?.blogSubTitle}
            <span class="blog-sub-title">{data?.blogSubTitle}</span>
          {/if}
        </div>
        {#if data?.date || data?.readTime}
          <HorizontalDivider height={isResponsive ? '1' : '2'} />
        {/if}
        <div class="blog-bottom-content">
          {#if data?.date}
            <div class="blog-published-div">
              <Icon glyph="icon-published-new" type="primary" desktopSize={28} />
              <Text key="extra.ampliance.blog.publish.text" args={[getBlogDateFormat(data.date)]} />
            </div>
          {/if}
          {#if data?.readTime}
            <div class="blog-read-div">
              <Icon glyph="icon-watch-icon" type="primary" desktopSize={28} />
              <Text key="extra.ampliance.blog.readtime.text" args={[data?.readTime]} />
            </div>
          {/if}
        </div>
      </div>
    </Content>
  </Card>
</a>

<style lang="scss">
  @import '../../common/styles/colors.new.scss';
  .blog-card-container {
    height: 100%;
    width: 440px;
    cursor: pointer;
    display: inline-block;
    color: $neutral-dark-02;
    font-weight: 400;
    text-decoration: none;
    border-radius: 24px;
    @include desktop-max-width {
      width: 164px;
    }
    &:hover {
      box-shadow: 0px 4px 4px 0px #00000040;
      color: inherit;
    }
    :global(.mdc-card) {
      height: 100%;
      border-radius: 24px;
      box-shadow: none;
    }
    :global(.smui-card__content) {
      padding: 33px;
      height: calc(100% - 331px);
      border: 1px solid $secondary-gray-02;
      border-radius: 0 0 24px 24px;
      background: rgba(249, 249, 249, 0.6);
      @include desktop-max-width {
        padding: 12px 8px;
        border-radius: 0 0 8px 8px;
        height: calc(100% - 164px);
      }
    }
    .blog-card-tag-container {
      padding: 16px;
      display: flex;
      gap: 8px;
      flex-wrap: wrap;
      :global {
        .tag {
          font-weight: 500;
          line-height: 14px;
          text-align: center;
          padding: 9px 8px;
          @include desktop-max-width {
            padding: 4px 12px;
          }
        }
      }
    }
    .blog-content-container {
      display: flex;
      flex-direction: column;
      gap: 20px;
      .blog-content-div {
        display: flex;
        flex-direction: column;
        gap: 4px;
        min-height: 104px;
        @include desktop-max-width {
          min-height: 64px;
        }
        .blog-title {
          font-size: 32px;
          line-height: 40px;
          color: $neutral-dark-01;
          font-weight: 700;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
          @include desktop-max-width {
            font-size: 15px;
            line-height: 18px;
          }
        }
        .blog-sub-title {
          font-size: 18px;
          line-height: 20px;
          color: $neutral-dark-01;
          font-weight: 400;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          @include desktop-max-width {
            font-size: 12px;
            line-height: 24px;
          }
        }
      }
    }
    .blog-bottom-content {
      display: flex;
      flex-direction: column;
      gap: 8px;
      white-space: nowrap;
      .blog-published-div,
      .blog-read-div {
        display: flex;
        align-items: center;
        gap: 6px;
        font-size: 18px;
        line-height: 20px;
        @include desktop-max-width {
          font-size: 10px;
          line-height: 16px;
        }
      }
    }
  }
  * :global(.card-media) {
    min-height: 331px;
    border-radius: 20px 20px 0 0;
    @include desktop-max-width {
      min-height: 164px;
      border-radius: 8px 8px 0 0;
    }
  }
</style>
